export enum DeviceTypeEnum {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  H5 = 'H5',
}

export enum IDownloadType {
  GOOGLE_PLAY = 'GOOGLE_PLAY',
  IOS = 'IOS',
  HUAWEI = 'HUAWEI'
}

export enum ILocation {
  HOME = 'HOME',
  FAQ = 'FAQ',
  EDUCATION = 'EDUCATION'
}
